export function getBaseUrls() {
    const hostname = window.location.hostname;

    const environments = {
        staging: ['staging', 'localhost', 'supportdev'],
        dev: ['dev', 'beta'],
        production: [] // Default case
    };

    // Identify the environment
    let env = 'production'; // Default to production
    if (environments.staging.some(envName => hostname.includes(envName))) {
        env = 'staging';
    } else if (environments.dev.some(envName => hostname.includes(envName))) {
        env = 'dev';
    }

    // Define base URLs
    const config = {
        staging: {
            baseURL: process.env.VUE_APP_API_BASE_URL_STAGING,
            inboxBaseURL: process.env.VUE_APP_INBOX_API_BASE_URL_STAGING,
            integrationBaseURL: process.env.VUE_APP_INTEGRATIONS_API_BASE_URL_STAGING,
            teamsBaseURL: process.env.VUE_APP_TEAMS_API_BASE_URL_STAGING,
            aiBaseURL: process.env.VUE_APP_AI_API_BASE_URL_STAGING,
            logEventsBaseURL: process.env.VUE_APP_EVENT_HISTORY_URL_STAGING,
            webSocketBaseURL: process.env.VUE_APP_WEBSOCKET_STAGING,
            widgetBaseURL: hostname === 'localhost'
                ? process.env.VUE_APP_WIDGET_BASE_URL_LOCAL
                : process.env.VUE_APP_WIDGET_BASE_URL_STAGING, 
            automationsBaseURL: hostname === 'localhost'
                ? process.env.VUE_APP_AUTOMATIONS_URL_LOCAL
                : process.env.VUE_APP_AUTOMATIONS_URL_STAGING,
            formBuilderBaseURL: process.env.VUE_APP_FORMBUILDER_URL_STAGING,
            reportsBaseURL: process.env.VUE_APP_REPORTS_API_URL_STAGING,
            activityBaseURL:process.env.VUE_APP_ACTIVITY_BASE_URL_STAGING,
            sentryEnv: process.env.VUE_APP_SENTRY_ENV_DEV,
            appBaseURL: hostname === 'localhost'
            ? process.env.VUE_APP_WIDGET_BASE_URL_LOCAL
            : process.env.VUE_APP_WIDGET_BASE_URL_STAGING,
            articlesBaseURL: process.env.VUE_APP_ARTICLES_API_URL,
            flowBuilderBaseURL: process.env.VUE_APP_FLOWBUILDER_URL_STAGING,
            flowBuilderApiBaseURL: process.env.VUE_APP_FLOWBUILDER_API_URL_STAGING,
            aiSearchBaseURL: process.env.VUE_APP_AI_ARTICLES_SEARCH_URL_STAGING,
            adminBaseURL: process.env.VUE_APP_ADMIN_API_URL_STAGING,
            userFlowBaseURL: process.env.VUE_APP_USER_FLOW_API_URL_STAGING,
            pineconeBaseURL: process.env.VUE_APP_PINE_CONE_API_URL_STAGING,
            chatSyncBaseURL: process.env.VUE_APP_CHAT_SYNC_API_URL_STAGING,
            agentBaseURL: process.env.VUE_APP_AGENT_API_URL_STAGING,
            aiWorkflowsBaseURL: process.env.VUE_APP_AI_WORKFLOWS_API_URL_STAGING,
            vaultBaseURL: process.env.VUE_APP_VAULT_API_URL_STAGING,
            joinModalBaseUrl: hostname === 'localhost'
                ? process.env.VUE_APP_JOIN_USER_BASE_URL_LOCAL 
                : process.env.VUE_APP_JOIN_USER_BASE_URL_STAGING
        },
        dev: {
            baseURL: process.env.VUE_APP_API_BASE_URL_DEV,
            inboxBaseURL: process.env.VUE_APP_INBOX_API_BASE_URL_DEV,
            integrationBaseURL: process.env.VUE_APP_INTEGRATIONS_API_BASE_URL_DEV,
            teamsBaseURL: process.env.VUE_APP_TEAMS_API_BASE_URL_DEV,
            aiBaseURL: process.env.VUE_APP_AI_API_BASE_URL_DEV,
            logEventsBaseURL: process.env.VUE_APP_EVENT_HISTORY_URL,
            webSocketBaseURL: process.env.VUE_APP_WEBSOCKET_DEV,
            widgetBaseURL: process.env.VUE_APP_WIDGET_BASE_URL_DEV,
            automationsBaseURL: process.env.VUE_APP_AUTOMATIONS_URL_DEV,
            formBuilderBaseURL: process.env.VUE_APP_FORMBUILDER_URL_DEV,
            reportsBaseURL: process.env.VUE_APP_REPORTS_API_URL_DEV,
            activityBaseURL:process.env.VUE_APP_ACTIVITY_BASE_URL_DEV,
            sentryEnv: process.env.VUE_APP_SENTRY_ENV,
            appBaseURL: process.env.VUE_APP_WIDGET_BASE_URL_DEV,
            articlesBaseURL: process.env.VUE_APP_ARTICLES_API_URL,
            flowBuilderBaseURL: process.env.VUE_APP_FLOWBUILDER_URL_DEV,
            flowBuilderApiBaseURL: process.env.VUE_APP_FLOWBUILDER_API_URL_DEV,
            aiSearchBaseURL: process.env.VUE_APP_AI_ARTICLES_SEARCH_URL_DEV,
            adminBaseURL: process.env.VUE_APP_ADMIN_API_URL_DEV,
            userFlowBaseURL: process.env.VUE_APP_USER_FLOW_API_URL_DEV,
            pineconeBaseURL: process.env.VUE_APP_PINE_CONE_API_URL_DEV,
            chatSyncBaseURL: process.env.VUE_APP_CHAT_SYNC_API_URL_DEV,
            agentBaseURL: process.env.VUE_APP_AGENT_API_URL_DEV,
            aiWorkflowsBaseURL: process.env.VUE_APP_AI_WORKFLOWS_API_URL_DEV,
            vaultBaseURL: process.env.VUE_APP_VAULT_API_URL_DEV,
            joinModalBaseUrl:process.env.VUE_APP_JOIN_USER_BASE_URL_DEV
        },
        production: {
            baseURL: process.env.VUE_APP_API_BASE_URL,
            inboxBaseURL: process.env.VUE_APP_INBOX_API_BASE_URL,
            integrationBaseURL: process.env.VUE_APP_INTEGRATIONS_API_BASE_URL,
            teamsBaseURL: process.env.VUE_APP_TEAMS_API_BASE_URL,
            aiBaseURL: process.env.VUE_APP_AI_API_BASE_URL,
            logEventsBaseURL: process.env.VUE_APP_EVENT_HISTORY_URL,
            webSocketBaseURL: process.env.VUE_APP_WEBSOCKET,
            widgetBaseURL: process.env.VUE_APP_WIDGET_BASE_URL,
            automationsBaseURL: process.env.VUE_APP_AUTOMATIONS_URL,
            formBuilderBaseURL: process.env.VUE_APP_FORMBUILDER_URL,
            reportsBaseURL: process.env.VUE_APP_REPORTS_API_URL,
            activityBaseURL:process.env.VUE_APP_ACTIVITY_BASE_URL,
            sentryEnv: process.env.VUE_APP_SENTRY_ENV,
            appBaseURL: process.env.VUE_APP_WIDGET_BASE_URL,
            articlesBaseURL: process.env.VUE_APP_ARTICLES_API_URL,
            flowBuilderBaseURL: process.env.VUE_APP_FLOWBUILDER_URL,
            flowBuilderApiBaseURL: process.env.VUE_APP_FLOWBUILDER_API_URL,
            aiSearchBaseURL: process.env.VUE_APP_AI_ARTICLES_SEARCH_URL,
            adminBaseURL: process.env.VUE_APP_ADMIN_API_URL,
            userFlowBaseURL: process.env.VUE_APP_USER_FLOW_API_URL,
            pineconeBaseURL: process.env.VUE_APP_PINE_CONE_API_URL,
            chatSyncBaseURL: process.env.VUE_APP_CHAT_SYNC_API_URL,
            agentBaseURL: process.env.VUE_APP_AGENT_API_URL,
            aiWorkflowsBaseURL: process.env.VUE_APP_AI_WORKFLOWS_API_URL,
            vaultBaseURL: process.env.VUE_APP_VAULT_API_URL,
            joinModalBaseUrl:process.env.VUE_APP_JOIN_USER_BASE_URL
        }
    };

    // Return the appropriate environment configuration
    return config[env];
}
